module.exports = __webpack_public_path__ + "static/RiTechLogo-5739c658609969ec98e88969ea6723aa.svg";